import React from 'react'
import { BtnWithIcon } from '@components/ui/btn/BtnWithIcon'
import styles from './styles.module.css'
import { cloudfrontPath } from '@utils/image'

interface Props {
  objectiveName: string
}

export const CategoryNavigatorImage = ({
  objectiveName,
}: Props): JSX.Element => {
  const imagePath = `${cloudfrontPath}/images/programs/top_banner/${objectiveName}.png`

  const toProgramList: React.MouseEventHandler<HTMLElement> = (e) => {
    e.preventDefault()
    window.location.href = '#programList'
  }

  const toArticles: React.MouseEventHandler<HTMLElement> = (e) => {
    e.preventDefault()
    window.location.href = '#articles'
  }
  return (
    <div
      className={styles['category-navigator-image']}
      style={{
        background: `url(${imagePath}) no-repeat center center / cover`,
      }}
    >
      <div className={styles['category-navigator-filter']}>
        <div className={styles['button-set']}>
          <div className="lg:m-[2.8vw]">
            <BtnWithIcon
              className={styles['button']}
              text="プログラム一覧"
              onClick={toProgramList}
              leftSideIconPath="/image/file-user.svg"
              rightSideIconPath="/image/under-the-direction-arrow.svg"
            />
          </div>
          <div className="lg:m-[2.8vw]">
            <BtnWithIcon
              className={styles['button']}
              text="最新情報を学ぶ"
              onClick={toArticles}
              leftSideIconPath="/image/learn.svg"
              rightSideIconPath="/image/under-the-direction-arrow.svg"
            />
          </div>
        </div>
      </div>
    </div>
  )
}
